var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoenload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.543,
    height: 10.543,
    viewBox: "0 0 10.543 10.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-data-transfer-download",
    "data-name": "Icon open-data-transfer-download",
    d: "M5.014,0V5.271H1.5l5.271,5.271,5.271-5.271H8.529V0Z",
    transform: "translate(-1.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoenload);
export default __webpack_public_path__ + "static/media/doenload.e89a71bb769aee43a193ca990a1aea0a.svg";
export { ForwardRef as ReactComponent };